import { render } from "./Trips.vue?vue&type=template&id=3e388907&scoped=true"
import script from "./Trips.vue?vue&type=script&lang=js"
export * from "./Trips.vue?vue&type=script&lang=js"

import "./Trips.vue?vue&type=style&index=0&id=3e388907&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e388907"]])

export default __exports__